import { Build } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const SetupGuideIcon: React.FC<SvgIconProps> = (props) => <Build {...props} />;

export default SetupGuideIcon;
